module.exports = __webpack_public_path__ + "static/media/timer_start_bg.5e280079.svg";